
    import _Handlebars from 'handlebars/runtime';

    var Handlebars = _Handlebars.default;
    import "@canvas/i18n";
import "@canvas/handlebars-helpers/index.js";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = '/var/canvas/ui/features/manage-groups/jst/assignToGroupMenu';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, functionType="function", self=this;

function program1(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n    <p tabindex=\"-1\">\n      "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("groups.manage.assign_to_group_menu")
  },data:data},helper ? helper.call(depth0, "groups.manage.assign_to_group_menu.no_groups_created", "Groups need to be created before users can be added.", options) : helperMissing.call(depth0, "t", "groups.manage.assign_to_group_menu.no_groups_created", "Groups need to be created before users can be added.", options)))
    + "\n    </p>\n  ";
  return buffer;
  }

function program3(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n    <p class='separated' tabindex=\"-1\">\n      ";
  stack1 = (helper = helpers.__i18nliner_safe || (depth0 && depth0.__i18nliner_safe),options={hash:{},data:data},helper ? helper.call(depth0, "<br>", options) : helperMissing.call(depth0, "__i18nliner_safe", "<br>", options));
  buffer += escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'br': (stack1),
    'i18n_scope': ("groups.manage.assign_to_group_menu")
  },data:data},helper ? helper.call(depth0, "groups.manage.assign_to_group_menu.all_groups_full", "All groups are full. %{br}", options) : helperMissing.call(depth0, "t", "groups.manage.assign_to_group_menu.all_groups_full", "All groups are full. %{br}", options)))
    + "\n      "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("groups.manage.assign_to_group_menu")
  },data:data},helper ? helper.call(depth0, "groups.manage.assign_to_group_menu.all_groups_full_suggestion", "Either change group limits or add more groups.", options) : helperMissing.call(depth0, "t", "groups.manage.assign_to_group_menu.all_groups_full_suggestion", "Either change group limits or add more groups.", options)))
    + "\n    </p>\n  ";
  return buffer;
  }

function program5(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n      ";
  stack1 = helpers.unless.call(depth0, (depth0 && depth0.isFull), {hash:{},inverse:self.noop,fn:self.program(6, program6, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    ";
  return buffer;
  }
function program6(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n        <li>\n          <a role=\"button\"\n             href=\"#\"\n             class=\"set-group ellipsis\"\n             data-group-id=\"";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\"\n             title=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("groups.manage.assign_to_group_menu")
  },data:data},helper ? helper.call(depth0, "groups.manage.assign_to_group_menu.assign_user_to_group", "Assign user to this group", options) : helperMissing.call(depth0, "t", "groups.manage.assign_to_group_menu.assign_user_to_group", "Assign user to this group", options)))
    + "\"\n             aria-label=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'name': ((depth0 && depth0.name)),
    'i18n_scope': ("groups.manage.assign_to_group_menu")
  },data:data},helper ? helper.call(depth0, "groups.manage.assign_to_group_menu.assign_user_to_group_name", "Assign user to groupo %{name}", options) : helperMissing.call(depth0, "t", "groups.manage.assign_to_group_menu.assign_user_to_group_name", "Assign user to groupo %{name}", options)))
    + "\"\n            >";
  if (helper = helpers.name) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.name); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</a>\n        </li>\n      ";
  return buffer;
  }

  buffer += "<div class=\"popover-title\">\n  "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("groups.manage.assign_to_group_menu")
  },data:data},helper ? helper.call(depth0, "groups.manage.assign_to_group_menu.add_to_group", "Add to Group", options) : helperMissing.call(depth0, "t", "groups.manage.assign_to_group_menu.add_to_group", "Add to Group", options)))
    + "\n</div>\n\n<div class='popover-content'>\n  ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.noGroups), {hash:{},inverse:self.noop,fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.allFull), {hash:{},inverse:self.noop,fn:self.program(3, program3, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n\n  <ul class=\"unstyled assign-to-groups\">\n    <li class=\"focus-bound\" tabindex=\"0\"></li>\n    ";
  stack1 = helpers.each.call(depth0, (depth0 && depth0.groups), {hash:{},inverse:self.noop,fn:self.program(5, program5, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    <li class=\"focus-bound\" tabindex=\"0\"></li>\n  </ul>\n</div>\n";
  return buffer;
  });
    ;
    
    import brandableCss from '@canvas/brandable-css';

    brandableCss.loadStylesheetForJST({
      id: '0c',
      bundle: 'jst/groups/manage/assignToGroupMenu'
    });
  ;
    export default templates[name];
  